import React from 'react';
import ReactDOM from 'react-dom';
import { DesignDlrApp } from './DesignDlrApp';
import './styles/styles.scss';

ReactDOM.render(
  <>
    <DesignDlrApp />
  </>,
  document.getElementById('root')
);
